export function formatMoney(price: string | number) {
  if (!price) {
    return '';
  }

  if (typeof price === 'string') {
    price = parseFloat(price);
  }

  return price.toLocaleString('de-CH', {
    style: 'currency',
    currency: 'CHF',
  });
}
